// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rt-6";
export var imgContainer = "_rt-3";
export var menuIcon = "_rt-5";
export var pillWrapper = "_rt-2";
export var pillsContainer = "_rt-1";
export var subscriptionCard = "_rt-0";
export var subscriptionLogo = "_rt-4";